var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainResponsivBgIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 412,
    viewBox: "0 0 187 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 69.5532,
    width: 89.8892,
    height: 316.363,
    rx: 44.9446,
    transform: "rotate(-49.9455 0 69.5532)",
    fill: "url(#paint0_linear_336_109145)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1215,
    y: 228.52,
    width: 78.2574,
    height: 276.809,
    rx: 39.1287,
    transform: "rotate(-49.9455 12.1215 228.52)",
    stroke: "url(#paint1_linear_336_109145)",
    strokeWidth: 7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_336_109145",
    x1: 44.9446,
    y1: 69.5532,
    x2: 44.9446,
    y2: 385.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EEAD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_109145",
    x1: 49.8189,
    y1: 228.946,
    x2: 49.8189,
    y2: 512.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98B6F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainResponsivBgIc);
export default __webpack_public_path__ + "static/media/mainResponsivBg_ic.2d42a822.svg";
export { ForwardRef as ReactComponent };